import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { map } from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@fgb/portal-component-library/src/lib/directives';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from '@ngx-translate/core';

const _c0 = function () { return ["/ticketTransfer/confirm"]; };
function SelectedTicketsCountComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 1);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelement(6, "span", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const count_r1 = ctx.ngSubscribe;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("Tickets Selected: ", count_r1, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction0(6, _c0))("disabled", count_r1 < 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 4, "cl.selected.tickets.count.button.text"), " ");
} }
class SelectedTicketsCountComponent {
    constructor(ticketsQuery) {
        this.ticketsQuery = ticketsQuery;
    }
    ngOnInit() {
        this.selectedTickets = this.ticketsQuery.selectedTickets().pipe(map((tickets) => {
            if (tickets != null) {
                return tickets.length;
            }
            else {
                return 0;
            }
        }));
    }
}
SelectedTicketsCountComponent.ɵfac = function SelectedTicketsCountComponent_Factory(t) { return new (t || SelectedTicketsCountComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TicketQuery)); };
SelectedTicketsCountComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SelectedTicketsCountComponent, selectors: [["fgbcl-selected-tickets-count"]], decls: 1, vars: 1, consts: [[4, "ngSubscribe"], [1, "btn", "btn-primary", 3, "routerLink", "disabled"], [1, "icon-forward-7"]], template: function SelectedTicketsCountComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SelectedTicketsCountComponent_ng_container_0_Template, 7, 7, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSubscribe", ctx.selectedTickets);
    } }, directives: [ɵngcc2.NgSubscribeDirective, ɵngcc3.RouterLink], pipes: [ɵngcc4.TranslatePipe], styles: [""] });
SelectedTicketsCountComponent.ctorParameters = () => [
    { type: TicketQuery }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectedTicketsCountComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-selected-tickets-count',
                template: "<ng-container *ngSubscribe=\"selectedTickets as count\">\r\n  <p>Tickets Selected: {{ count }}</p>\r\n  <button [routerLink]=\"['/ticketTransfer/confirm']\" class=\"btn btn-primary\" [disabled]=\"count < 1\">\r\n    {{ 'cl.selected.tickets.count.button.text' | translate }} <span class=\"icon-forward-7\"></span>\r\n  </button>\r\n</ng-container>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.TicketQuery }]; }, null); })();

class SelectedTicketsCountModule {
}
SelectedTicketsCountModule.ɵfac = function SelectedTicketsCountModule_Factory(t) { return new (t || SelectedTicketsCountModule)(); };
SelectedTicketsCountModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SelectedTicketsCountModule });
SelectedTicketsCountModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            RouterModule,
            DirectivesModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SelectedTicketsCountModule, { declarations: function () { return [SelectedTicketsCountComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        RouterModule,
        DirectivesModule, ɵngcc4.TranslateModule]; }, exports: function () { return [SelectedTicketsCountComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectedTicketsCountModule, [{
        type: NgModule,
        args: [{
                declarations: [SelectedTicketsCountComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    RouterModule,
                    DirectivesModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [SelectedTicketsCountComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { SelectedTicketsCountComponent, SelectedTicketsCountModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-tickettransfer-selected-tickets-count.js.map